import { Paper, Stack, StackProps, Typography } from '@mui/material';
import React from 'react';

interface FormSectionProps extends StackProps {
  children?: React.ReactNode;
  title?: string;
  subTitle?: string;
  rightSection?: React.ReactNode;
}

// TODO: add unit tests
// - test for title and subTitle
function FormSection({ children, title, subTitle, rightSection }: FormSectionProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Stack>
          {title && (
            <Typography variant="h5" mb={subTitle ? 0 : 1.5}>
              {title}
            </Typography>
          )}
          {subTitle && (
            <Typography variant="body2" color="#616161">
              {subTitle}
            </Typography>
          )}
        </Stack>
        <Stack>{rightSection}</Stack>
      </Stack>
      <Stack spacing={2}>{children}</Stack>
    </Paper>
  );
}

export default FormSection;
